import { render, staticRenderFns } from "./OrganisationData.vue?vue&type=template&id=2c938b00&"
import script from "./OrganisationData.vue?vue&type=script&lang=js&"
export * from "./OrganisationData.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports